import Vue from 'vue'
import App from './App'
import { message, modal, Tabs, Row, Col, Icon, Form, Button, Radio, Input, Select } from 'ant-design-vue'
import FlightSearchMenu from '@/components/flightsearchmenu'

import 'ant-design-vue/lib/style/components.less'
// 公共样式
import '@/assets/css/global.less'
// air-ui组件库样式
import '@/assets/css/air-ui.less'
import './css/queryMenu.less'

Vue.use(Tabs)
Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Select)
Vue.use(Form)
Vue.use(modal)
Vue.use(FlightSearchMenu)
Vue.prototype.$info = modal.info
Vue.prototype.$message = message
Vue.config.productionTip = false

let instance = null

function loadTheme (prefix, theme) {
  // 开发环境不需要手动加载 css，直接更改 html class 即可
  // 构建后才会提取 css 文件
  if (process.env.NODE_ENV === 'production') {
    const _scopeName = `theme-${theme}`
    // eslint-disable-next-line no-undef
    const themeTimestampArr = __THEME_TIMESTAMP__
    const themeFileTimestamp = (themeTimestampArr.find(({ scopeName }) => _scopeName === scopeName) || {}).mtime
    const linkEl = document.createElement('link')
    linkEl.type = 'text/css'
    linkEl.rel = 'stylesheet'
    linkEl.href = prefix + `css/${_scopeName}-${themeFileTimestamp}.css`
    const parent = document.getElementsByTagName(theme === 'default' ? 'head' : 'qiankun-head')[0]
    parent.insertBefore(linkEl, parent.getElementsByTagName('link')[0])
  }
}

function render (props = {}) {
  const { container } = props

  /* eslint-disable no-new */
  instance = new Vue({
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap () {
  console.log('main app bootstraped')
}
export async function mount (props) {
  console.log('main app mount')
  const airline = window.__MICRO_ROOT__?.airline || 'default'
  loadTheme(window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__, airline)
  window.__MICRO_ROOT__?.eventBus?.emit('micro_app:loading', null, false)

  // 二次进入时，js已在内存，会直接匹配路由开始渲染；
  // 当css extra时，css要走网络资源再插入，这可能会比渲染慢，所以延迟让渲染等等
  // 当然最佳的方式还是使用css体验沙箱
  setTimeout(() => {
    render(props)
  }, 100)
}
export async function unmount () {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}
